import axios from 'axios';
import services from "@/config/services";

const FLUSSI_URL = services.ask_flussi_api.url + '/sync-management';

export default {
    getGroups() {
        return axios.get(`${FLUSSI_URL}/configs`);
    },

    createGroup(payload) {
        return axios.post(`${FLUSSI_URL}/configs`, payload);
    },

    addTable(configId, payload) {
        return axios.post(`${FLUSSI_URL}/configs/${configId}/tables`, payload);
    },

    deleteTable(tableId) {
        return axios.delete(`${FLUSSI_URL}/tables/${tableId}`);
    },

    getSyncTypes() {
        return axios.get(`${FLUSSI_URL}/types`);
    },

    getDatabases() {
        return axios.get(`${FLUSSI_URL}/databases`);
    },

    updateTableStatus(tableId, attivo) {
        return axios.patch(`${FLUSSI_URL}/tables/${tableId}/status`, {
            attivo
        });
    },

    deleteGroup(configId) {
        return axios.delete(`${FLUSSI_URL}/configs/${configId}`);
    },

    getJobs(params = {}) {
        return axios.get(`${FLUSSI_URL}/jobs`, { params });
    },

    getJobTables(jobId) {
        return axios.get(`${FLUSSI_URL}/jobs/${jobId}/tables`);
    },

    getLatestJobsByGroup() {
        return axios.get(`${FLUSSI_URL}/jobs/latest-by-group`);
    },

    updateGroup(configId, payload) {
        return axios.patch(`${FLUSSI_URL}/configs/${configId}`, payload);
    },

    updateGroupStatus(configId, attivo) {
        return axios.patch(`${FLUSSI_URL}/configs/${configId}/status`, {
            attivo
        });
    },

    runGroupNow(configId) {
        return axios.post(`${FLUSSI_URL}/configs/${configId}/run`);
    },

    updateTable(tableId, payload) {
        return axios.patch(`${FLUSSI_URL}/tables/${tableId}`, payload);
    },

    updateNotifications(configId, payload) {
        return axios.patch(`${FLUSSI_URL}/configs/${configId}/notifications`, payload);
    },

    previewCron(cronExpression) {
        return axios.post(`${FLUSSI_URL}/cron-preview`, {
            cron_expression: cronExpression
        });
    },
};